module.exports = __webpack_public_path__ + "static/media/icon_add_line.2004b910.svg";